import { render, staticRenderFns } from "./OfficialAccountLogin.vue?vue&type=template&id=5d2975e7&scoped=true&"
import script from "./OfficialAccountLogin.vue?vue&type=script&lang=js&"
export * from "./OfficialAccountLogin.vue?vue&type=script&lang=js&"
import style0 from "./OfficialAccountLogin.vue?vue&type=style&index=0&id=5d2975e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2975e7",
  null
  
)

export default component.exports